import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from 'app/core/user/user.types';
import { DataCollectorService } from '../services/data_collector_services/data_collector_service.service';
import { SignInService } from '../services/signin/sigin.service';
import { LocalStorageService } from '../services/localstorage.service';
import { Router } from '@angular/router';
import { ZuperSdkService } from '../services/sdk_service/sdk.services';
import { AnalyticsService } from '../services/analytics/analytics.service';

@Injectable({
    providedIn: 'root'
})
export class UserService
{
    basicUserObj = {
        user_uid: '',
        email: '',
        role: '',
        first_name: '',
        last_name: '',
        profile_picture: '',
        custom_fields: '',
        avatar: '',
        status: '',
    };
    currentUserData: any = {};
    isUserLoggedOut: boolean = false;
    public _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    public logout$: Subject<boolean> = new Subject();

    /**
     * Constructor
     */
    constructor(private _dataCollectorService: DataCollectorService,
                private _localStorageService: LocalStorageService,
                private _router: Router,
                private _httpClient: HttpClient,
                private signInService: SignInService,
                private analyticsService: AnalyticsService
            )
    {
        this._user.next(this.basicUserObj);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    };

     // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // logouts out user and clears localstorage
    signOut(data: any = {}): void
    {
        this._dataCollectorService.postData(this.signInService.logoutUrl(), data).subscribe((response: any)=>{
            this.isUserLoggedOut = true;
            this.analyticsService.reset();
            this._localStorageService.removeAllLocalstorage();
            this.logout$.next(true);
            this._router.navigateByUrl('/login');
        });
    }

}
